<template>
    <div :class="[
        'consent-manager',
        { 'is-disabled': isDisabled },
        { 'is-open': isOpen }
    ]">
        <a
            v-bastards
            class="consent-manager-toggler fs-18 link-underline-out"
            title="Zarządzaj swoimi zgodami marketingowymi"
            @click="isOpen = !isDisabled ? !isOpen : false"
        >
            <i class="icon-noun_option" /> Zarządzaj swoimi zgodami marketingowymi
        </a>
        <div class="consent-manager-toggleable">
            <ConsentEditGroup v-if="items.length > 0">
                <ConsentEdit 
                    v-for="item in items"
                    ref="consent"
                    :key="item.label"
                    :label="item.label"
                    :input-label="item.inputLabel"
                    :input-type="item.inputType"
                    :input-value="item.inputValue"
                    :is-checked="item.isGranted"
                    :name="item.name"
                    :type="item.type"
                />
            </ConsentEditGroup>

            <CardInfo
                v-if="cardData"
                :number="cardData.cardNumber"
                :full-name="cardData.fullName"
                :company-name="companyData.fullName"
                :company-data="companyData.info"
            />

            <div class="placeholder placeholder-85">
                <ButtonSave 
                    :is-disabled="false"
                    :theme="['thin', 'right']"
                    label-html="Zapisz zmiany"
                    @click.native="onClickSave"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ButtonSave from '@/components/button/ButtonSave'
import CardInfo from '@/components/card/CardInfo'
import ConsentEdit from '@/components/consent/ConsentEdit'
import ConsentEditGroup from '@/components/consent/ConsentEditGroup'

export default {
    components: {
        ButtonSave,
        CardInfo,
        ConsentEdit,
        ConsentEditGroup
    },

    props: {
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        items: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    data() {
        return {
            isOpen: false
        }
    },

    computed: {
        cardData() {
            return this.$store.getters['apiCustomer/cardData']
        },

        companyData() {
            return this.$store.getters['apiCustomer/companyData']
        }
    },

    watch: {
        isOpen(value) {
            this.$emit('open', value)
        }
    },

    methods: {
        onClickSave() {
            this.$emit('save')
        },

        validate() {
            let validated = true

            this.$refs.consent.forEach(item => {
                const isItemValidated = item.validate()

                validated = validated && isItemValidated
            })

            return validated
        }
    }
}
</script>

<style lang="scss">
.consent-manager {
    padding: 45px 0 0 0;

    &-toggler {
        cursor: pointer;
        margin: 0 100px;

        > [class^="icon-"] {
            position: absolute;
            left: -42px;
            top: -3px;
            font-size: 38px;
        }
    }

    &-toggleable {
        @include transition(opacity .200s ease-in-out);
        overflow: hidden;
        padding: 56px 0 0;
        max-height: 0;
        opacity: 0;
    }

    &.is-disabled {
        pointer-events: none;
        opacity: .39;
    }

    &.is-open:not(.is-disabled) {
        padding-bottom: 23px;
    }

    &.is-open:not(.is-disabled) & {
        &-toggleable {
            max-height: unset;
            max-height: none;
            opacity: 1;
        }
    }

    @media (max-width: $screen-laptop) {
        &-toggler {
            display: block;
            margin: 0 35px;
            max-width: calc(50% - 85px);
        }
    }

    @media (max-width: $screen-tablet) {
        padding: 124px 0 0;

        &-toggleable {
            padding-top: 40px;
        }

        &-toggler {
            display: inline;
            max-width: 100%;
        }
    }

    @media  (max-width: $screen-mobile-landscape) {
        padding-top: 10px;

        &-toggleable {
            padding-top: 30px;
        }

        &-toggler {
            display: block;
        }
    }
}
</style>
